import createIcon from '../../createIcon';

/**
 * @component @name AssistantDirection
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTQgMTBIOUM4LjQgMTAgOCAxMC40IDggMTFWMTVIMTBWMTJIMTRWMTQuNUwxNy41IDExTDE0IDcuNVYxMFpNMTIgMUM1LjkgMSAxIDUuOSAxIDEyQzEgMTguMSA1LjkgMjMgMTIgMjNDMTguMSAyMyAyMyAxOC4xIDIzIDEyQzIzIDUuOSAxOC4xIDEgMTIgMVpNMTkuNzMgMTIuNThMMTIuNTQgMTkuOEMxMi4xOSAyMC4wNyAxMS43NSAyMC4wNyAxMS4zOSAxOS44TDQuMiAxMi41OEMzLjkzIDEyLjIyIDMuOTMgMTEuNzggNC4yIDExLjQyTDExLjM5IDQuMkMxMS43NCAzLjkzIDEyLjE4IDMuOTMgMTIuNTQgNC4yTDE5LjczIDExLjQyQzIwLjA5IDExLjY5IDIwLjA5IDEyLjIyIDE5LjczIDEyLjU4WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const AssistantDirection = createIcon('AssistantDirection', [
  [
    'path',
    {
      d: 'M14 10H9C8.4 10 8 10.4 8 11V15H10V12H14V14.5L17.5 11L14 7.5V10ZM12 1C5.9 1 1 5.9 1 12C1 18.1 5.9 23 12 23C18.1 23 23 18.1 23 12C23 5.9 18.1 1 12 1ZM19.73 12.58L12.54 19.8C12.19 20.07 11.75 20.07 11.39 19.8L4.2 12.58C3.93 12.22 3.93 11.78 4.2 11.42L11.39 4.2C11.74 3.93 12.18 3.93 12.54 4.2L19.73 11.42C20.09 11.69 20.09 12.22 19.73 12.58Z',
      key: '5rdj7p',
    },
  ],
]);

export default AssistantDirection;
